import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Grid, Divider } from '@material-ui/core';
import { InfoWidget } from '@ds/react-components';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { ajaxActions } from 'common/ajax/store.js';
import { actionCreators } from './store.js';
import EditContactDetails from './EditContactDetails.js';
import SetAsPreferred from './SetAsPreferred.js';

const styles = (theme) => ({
  root: {},
  name: {
    marginBottom: 20,
  },
  data: {
    minHeight: 40,
  },
  dataType: {
    '& p': {
      color: theme.palette.common.lightText,
    },
  },
  dataContent: {
    '& p': {
      color: theme.palette.common.black,
    },
  },
  dataRight: {
    right: '0px',
  },
  divider: {
    marginTop: 20,
    marginBottom: 20,
  },
  indent: {
    padding: '10px 18px',
    '& a': {
      textDecoration: 'underline',
    },
    backgroundColor: '#f9fcfd',
  },
  edit: {
    position: 'relative',
    display: 'flex',
    float: 'right',
    top: '0px',
    right: '0px',
    color: '#004A8C !important',
    '&:hover': {
      color: '#002A64 !important',
    },
  },
  prefText: {
    position: 'relative',
    display: 'flex',
    float: 'right',
    top: '0px',
    right: '0px',
    color: '#004A8C !important',
  },
  prefTextPhones: {
    top: '0px',
    color: '#004A8C !important',
    right: '20px !important',
  },
  tags: {
    display: 'flex',
    '& span': {
      marginRight: 5,
    },
  },
});

const contacts = [
  {
    id: null,
    countryCode: '',
    number: '',
    type: 'PM',
    contactName: '',
    preferred: false,
  },
  {
    id: null,
    countryCode: '',
    number: '',
    type: 'PW',
    contactName: '',
    preferred: false,
  },
  {
    id: null,
    countryCode: '',
    number: '',
    type: 'PH',
    contactName: '',
    preferred: false,
  },
];

const getCountryCode = (value) => {
  if (value) return value.trim() === 'NZ' ? '+64' : '+61';
};

const getPhoneDetails = (value, country) => {
  let countryCodeDetails = '';
  const reg = /^0+/;
  if (country) {
    countryCodeDetails = getCountryCode(country);
  }

  if (value === undefined) {
    return contacts;
  }

  //remove 0 from the numbers when they have leading zero
  const removedLeadingZero = value.map((contact) =>
    reg.test(contact.number)
      ? { ...contact, number: contact.number.replace(reg, '') }
      : contact
  );

  let phoneContacts = removedLeadingZero;
  // predefined array contacts matching with array from customer profile
  // if data from customer profile doesn't have PW or PH or PM contact type then insert empty value for not existing type
  contacts.map((contact) => {
    let index = phoneContacts.findIndex((x) => x.type === contact.type);
    if (index !== -1) {
      return phoneContacts;
    }
    phoneContacts = [...phoneContacts, contact];
  });

  const result = phoneContacts.map((contact) =>
    (contact.countryCode !== null && country.id !== null) ||
    ((contact.countryCode === '+61' || contact.countryCode === '+64') &&
      contact.number)
      ? contact
      : { ...contact, countryCode: countryCodeDetails }
  );

  return result.sort((a, b) => a.type.localeCompare(b.type));
};

class ContactDetails extends React.Component {
  componentDidUpdate = (prevProps) => {
    const { profileDetails, getAccountDetails } = this.props;
    //const isLoading = false;

    if (
      (JSON.stringify(profileDetails.phoneNumbers) !==
        JSON.stringify(prevProps.profileDetails.phoneNumbers) ||
        JSON.stringify(profileDetails.emailAddresses) !==
          JSON.stringify(prevProps.profileDetails.emailAddresses)) &&
      JSON.stringify(prevProps.profileDetails.phoneNumbers) !== undefined
    ) {
      getAccountDetails(profileDetails.adfitNo);
      //  this.props.setAjaxStatus(!isLoading);
      this.props.updateAjaxStatus();
    }
  };

  getContactType = (contact) => {
    if (contact.type === 'PH')
      return 'Home' + (contact.preferred ? ', Preferred' : '');
    else if (contact.type === 'PM')
      return 'Mobile' + (contact.preferred ? ', Preferred' : '');
    else if (contact.type === 'PW')
      return 'Work' + (contact.preferred ? ', Preferred' : '');
    else if (contact.type === 'EM')
      return 'Email' + (contact.preferred ? ', Preferred' : '');
    else return '';
  };

  getPhoneNumber = (contact) => {
    if (contact.countryCode) return contact.countryCode + ' ' + contact.number;
    else return '—';
  };

  isNotAnytimeFit = (profileDetails) => {
    return profileDetails.facilityGroupName !== 'Anytime Fitness';
  };

  render() {
    const { classes, profileDetails } = this.props;
    const contactDetails =
      profileDetails &&
      getPhoneDetails(profileDetails.phoneNumbers, profileDetails.country);

    let phoneCount = 0,
      emailCount = 0;

    return (
      <Grid item>
        <InfoWidget
          title={'Contact Details'}
          classes={{ root: classes.root }}
          isLoading={!profileDetails.hasOwnProperty('phoneNumbers')}>
          {contactDetails &&
            contactDetails.map((contact, index) => {
              phoneCount++;
              return (
                <div key={'phone-' + index}>
                  {index !== 0 && <Divider className={classes.divider} />}
                  <Grid container className={classes.data}>
                    <Grid item xs={12} className={classes.dataLeft}>
                      <Typography>{this.getPhoneNumber(contact)}</Typography>
                    </Grid>
                    <Grid item xs={3} className={classes.dataType}>
                      <Typography>{this.getContactType(contact)}</Typography>
                    </Grid>
                    <Grid item xs={7} className={classes.prefTextPhones}>
                      <Typography>
                        {contact.preferred === true ||
                        contact.id === null ||
                        !this.isNotAnytimeFit(profileDetails) ? null : (
                          <SetAsPreferred
                            country={profileDetails.country}
                            currentContact={contact}
                            profileDetails={profileDetails}
                          />
                        )}
                      </Typography>
                    </Grid>
                    <Grid item xs={2} className={classes.dataRight}>
                      <Typography>
                        {this.isNotAnytimeFit(profileDetails) && (
                          <EditContactDetails
                            linkText="Edit"
                            getCountryCode={() =>
                              getCountryCode(profileDetails.country)
                            }
                            country={profileDetails.country}
                            profileDetails={profileDetails}
                            currentContact={contact}
                          />
                        )}
                      </Typography>
                    </Grid>
                  </Grid>
                </div>
              );
            })}

          {!profileDetails.emailAddresses === false ? (
            profileDetails.hasOwnProperty('emailAddresses') &&
            profileDetails.emailAddresses.map((contactEmail, index) => {
              emailCount++;
              return (
                <div key={'email-' + contactEmail.id}>
                  {(phoneCount > 0 || index !== 0) && (
                    <Divider className={classes.divider} />
                  )}
                  <Grid container className={classes.data}>
                    <Grid item xs={12} className={classes.dataContent}>
                      <Typography>{contactEmail.email}</Typography>
                    </Grid>
                    <Grid item xs={6} className={classes.dataType}>
                      <Typography>
                        {this.getContactType(contactEmail)}
                      </Typography>
                    </Grid>
                    <Grid item xs={6} className={classes.dataRight}>
                      {contactEmail.preferred === true ||
                      contactEmail.id === null ||
                      contactEmail.id === undefined ||
                      !this.isNotAnytimeFit(profileDetails) ? null : (
                        <SetAsPreferred
                          profileDetails={profileDetails}
                          currentContact={contactEmail}
                        />
                      )}
                    </Grid>
                  </Grid>
                </div>
              );
            })
          ) : (
            <div>
              <Divider className={classes.divider} />
              <Grid container className={classes.data}>
                <Grid item xs={12} className={classes.dataContent}>
                  <Typography>—</Typography>
                </Grid>
                <Grid item xs={6} className={classes.dataType}>
                  <Typography>Email</Typography>
                </Grid>
              </Grid>
            </div>
          )}

          {phoneCount === 0 && emailCount === 0 && (
            <Grid item xs={12} className={classes.dataType}>
              <Typography>None</Typography>
            </Grid>
          )}
        </InfoWidget>
      </Grid>
    );
  }
}
ContactDetails.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  ajax: state.ajax,
  localisation: state.localisation,
});

const mapDispatchToProps = (dispatch) => {
  return {
    updateAjaxStatus: () => {
      dispatch(ajaxActions.updateAjaxStatus());
    },
    getAccountDetails: (adfitNo) => {
      dispatch(actionCreators.getAccountDetails(adfitNo));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(ContactDetails));
